module.exports = __webpack_public_path__ + "img/kma_gallery16.7be161da.jpg";